import { render, staticRenderFns } from "./AddressResource.vue?vue&type=template&id=256132e6&"
import script from "./AddressResource.vue?vue&type=script&lang=js&"
export * from "./AddressResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports